var surround = require("./surround");
module.exports = function quote(str, quoteChar) {
  return surround(str, quoteChar || '"');
};
